module.exports = __webpack_public_path__ + "img/Ti9.e1047120.png";